export const DISPLAY_TOURNAMENTS = 'DISPLAY_TOURNAMENTS';
export const SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS = 'SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS';
export const START_LOADING_TOURNAMENTS = 'START_LOADING_TOURNAMENTS';
export const UPDATE_SHOW_ALL_TOURNAMENTS = 'UPDATE_SHOW_ALL_TOURNAMENTS';
export const SET_CAN_CREATE_TOURNAMENTS = 'SET_CAN_CREATE_TOURNAMENTS';
export const DISPLAY_GROUP_NAME = 'DISPLAY_GROUP_NAME';



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/constants.js